<div class="govuk-grid-row govuk-!-padding-5">
  <h3 class="govuk-heading-m">Notes</h3>

  <button type="button" govukSecondaryButton routerLink="notes/add-note">Add a note</button>

  @if (hasNotes()) {
    <ul class="govuk-list">
      @for (note of notes(); track note) {
        <li class="govuk-!-margin-bottom-0">
          <div class="govuk-grid-row">
            <div class="govuk-grid-column-two-thirds">
              <p class="govuk-body">{{ note.payload?.note }}</p>

              @if (note.payload?.files) {
                <ul class="govuk-list">
                  @for (file of note.payload?.files | keyvalue; track file.key) {
                    <li class="govuk-!-margin-bottom-1">
                      <a class="govuk-link" [routerLink]="['notes', 'file-download', file.key]">{{ file.value }}</a>
                    </li>
                  }
                </ul>
              }

              <p class="govuk-hint govuk-!-margin-bottom-0">
                {{ note.submitter }}, {{ note.lastUpdatedOn | date: 'd MMM yyyy, h:mma' }}
              </p>
            </div>

            <div class="govuk-grid-column-one-third govuk-!-text-align-right govuk-!-margin-top-2">
              <a class="govuk-link" [routerLink]="['notes', 'edit-note', note.id]">Edit</a>
              <a class="govuk-!-padding-left-3 govuk-link" [routerLink]="['notes', 'delete-note', note.id]">Delete</a>
            </div>
          </div>

          <hr class="govuk-footer__section-break govuk-!-margin-top-3 govuk-!-margin-bottom-3" />
        </li>
      }
    </ul>
  } @else {
    <p class="govuk-body">No notes have been added to this account yet.</p>
  }

  <cca-pagination
    [count]="state().totalItems"
    [currentPage]="currentPage()"
    [pageSize]="pageSize()"
    (pageChange)="onPageChange($event)"
    (pageSizeChange)="onPageSizeChange($event)"
  />
</div>
